import { CardIconType } from '@ui-components/containers/Card'
import { ReactElement, ReactNode, Ref } from 'react'

import { EmojiType } from '../assets/Emojis'
import { Assistant } from './Assistant'
import { SimplePhasesView, SimplePhasesViewProps } from './SimplePhasesView'

export type PhaseInstructions = Record<CompletionProgress, PhaseHeaderTexts>
export type PhaseInstructionOverride = Partial<Record<CompletionProgress, Partial<PhaseHeaderTexts>>>

export interface PhasesViewProps extends SimplePhasesViewProps {
  instructions: PhaseInstructions
  progress: CompletionProgress
  fullViewportHeight?: boolean
  ref?: Ref<HTMLDivElement>
  testId?: string
}

export interface PhaseHeaderTexts {
  title: string
  text: string
  additionalText?: string
}

export interface PhaseContent {
  icon?: CardIconType
  description?: string
  text: ReactNode
  action?: {
    onClick: () => unknown
    dataTestId?: string
  }
}

export interface Phase {
  header: string
  content: PhaseContent | ReactElement | null
  isComplete: boolean
  isFinalizationPhase?: boolean
}

export enum CompletionProgress {
  NotStarted = 'initial',
  Started = 'started',
  Incomplete = 'inProgress',
  IncompletePastHalf = 'pastHalfway',
  Complete = 'complete',
}

const completionProgressEmojis: Record<CompletionProgress, EmojiType> = {
  [CompletionProgress.NotStarted]: 'thumbUp',
  [CompletionProgress.Started]: 'raisedHands',
  [CompletionProgress.Incomplete]: 'thumbUp',
  [CompletionProgress.IncompletePastHalf]: 'raisedHands',
  [CompletionProgress.Complete]: 'heart',
}

const getEmoji = (progress: CompletionProgress): EmojiType => {
  return completionProgressEmojis[progress]
}

export const PhasesView = (props: PhasesViewProps) => {
  const { phases, instructions, phasesHeader, shouldShowCompletedPhases, fullViewportHeight, ref, progress, testId } =
    props

  const guidance = instructions[progress]

  return (
    <Assistant
      title={guidance.title}
      leadText={guidance.text}
      additionalText={guidance.additionalText}
      emoji={getEmoji(progress)}
      ref={ref}
      testId={testId}
      fullViewportHeight={fullViewportHeight}
    >
      <SimplePhasesView
        phasesHeader={phasesHeader}
        phases={phases}
        shouldShowCompletedPhases={shouldShowCompletedPhases}
      />
    </Assistant>
  )
}
